import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from '@mui/material';
import { Icon } from '@iconify/react';
import PropTypes from 'prop-types';
import { warning } from 'src/theme/palette';

export default function SessionExpiredDialog({ open, onLogin }) {
  return (
    <Dialog
      open={open}
      onClose={() => {}}
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 2,
          minWidth: 380,
          maxWidth: 420,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          color: warning.main,
          fontWeight: 700,
          fontSize: 20,
          justifyContent: 'center',
          pb: 0,
        }}
      >
        <Icon icon="mdi:alert" width={24} color={warning.main} />
        Sessiya muddati tugadi
      </DialogTitle>
      <DialogContent sx={{ textAlign: 'center', pt: 2 }}>
        <Box
          sx={{
            bgcolor: warning.lighter,
            color: warning.main,
            width: 64,
            height: 64,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            my: 2,
          }}
        >
          <Icon icon="mdi:alert" width={36} color={warning.main} />
        </Box>
        <Typography variant="h6" fontWeight={700} gutterBottom>
          Davom etish uchun qayta tizimga kirishingiz kerak.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
        <Button variant="contained" color="warning" onClick={onLogin}>
          Qayta kirish
        </Button>
      </DialogActions>
    </Dialog>
  );
}

SessionExpiredDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onLogin: PropTypes.func.isRequired,
};
